import React, {useState} from 'react'
import {Link} from 'react-router-dom'
import Layout from '../../layouts/centered'
import CenteredForm from '../../layouts/centered-form'
import {Form} from "react-final-form";
import InputField from "../../components/FinalForm/InputField";
import {apiLoginUser, apiResendConfirmAccount, axiosSetAuthorizationToken} from "./Actions";
import {useDispatch} from "react-redux";
import Alert from "../../components/alerts";
import {Button} from "../../components/My/Button";
import EmailField from "../../components/FinalForm/EmailField";
import {OPEN_WELCOME_MODAL, SET_ACCEPT_TERMS} from "../../reducers/user";


const LoginPage = () => {

    let [loading, setLoading] = useState(false)
    let [error, setError] = useState(null)
    let [info, setInfo] = useState(null)
    let [verifyEmail, setVerifyEmail] = useState(false)
    let [processingResend, setProcessingResend] = useState(false)
    let dispatch = useDispatch()


    const onLogin = (values) => {
        setError(null)
        setInfo(null)
        setLoading(true)
        apiLoginUser(values, (data) => {
            setLoading(false)
            axiosSetAuthorizationToken(data.token, dispatch);
            dispatch({type: SET_ACCEPT_TERMS, payload: data.data.acceptTerms})
            dispatch({type: OPEN_WELCOME_MODAL, payload: true})
        }, error => {
            setLoading(false);
            switch (error.type) {
                case "LOGIN_ERROR":
                    setError("Špatné přihlašovací údaje.");
                    setInfo(null);
                    break;
                case "USER_NOT_VERIFED":
                    setVerifyEmail(true);
                    setError("Účet nebyl dosud verifikován.");
                    setInfo(null)
                    break;
                case "LOGIN_DISABLED":
                    setError("Momentálně není možné se přihlásit, registrace nejsou spuštěné.")
                    setInfo(null)
                    break;
                default:
                    setError("Došlo k chybě")
            }
        })
    }

    const resendVerifyEmail = (form, values) => {
        if (processingResend) return;
        setProcessingResend(true);
        apiResendConfirmAccount(values.login, (data) => {
            setProcessingResend(false);
            form.reset();
            setVerifyEmail(false);
            setInfo("Potvrzovací email byl znovu odeslán, zkontrojte svou emailovou schránku a potvrďte registraci.")
            setError(null);
        }, (error) => {
            setProcessingResend(false);
            switch (error.type) {
                case "USER_NOT_FOUND":
                    setError("Špatný email.");
                    break;
                case "USER_ALREADY_VERIFED":
                    setError("Email už je ověřený.");
                    break;
                default:
                    setError("Došlo k chybě.");


            }

        })

    }

    return (
        <Layout>
            <div className={"flex flex-col w-full max-w-xl"}>
                <div className={"flex items-center justify-center pb-6"}>
                    <img
                        src={"https://enigoo-legends.s3.eu-central-1.amazonaws.com/fe_photos/2026/header_photos/header.jpeg"}
                        className={"h-72"} alt={"Legendy.cz"}/>
                </div>
                <CenteredForm subtitle="Uživatelská sekce">
                    {error && <Alert color={"text-red-500"} outlined={true}>{error}</Alert>}
                    {info && <Alert color={"text-yellow-600"} outlined={true}>{info}</Alert>}

                    <Form onSubmit={onLogin}
                          render={({handleSubmit, form, values}) => (
                              <>
                                  {verifyEmail && <span className={"p-2 underline cursor-pointer"} onClick={() => {
                                      resendVerifyEmail(form, values)

                                  }}>Znovu odeslat ověřovací email</span>}
                                  <form className="form flex flex-wrap w-full">
                                      <div className="w-full">
                                          <EmailField name={"login"} label={"Přihlašovací e-mail"}
                                                      placeholder={"Přihlašovací e-mail"} isMandatory={true}
                                                      onEnter={() => handleSubmit()}/>
                                      </div>
                                      <div className="w-full">
                                          <InputField name={"password"} inputType={"password"} label={"Heslo"}
                                                      isMandatory={true} onEnter={() => handleSubmit()}/>
                                      </div>
                                      <Button text={"Přihlásit se"} onClick={handleSubmit} loading={loading}/>
                                  </form>
                              </>
                          )}
                    />


                    <div className="flex flex-row w-full mt-3">
                        <span className="text-secondary mr-1">Nový uživatel?</span>
                        <span className={"text-legendyColor"}>
                            <Link className="link" to="/create-account">
                                <span className={"text-legendyColor"}>Vytvořte si svůj účet</span>
                            </Link>
                        </span>
                    </div>
                    <div className="w-full">
                      <span>
                        <Link className="link" to="/forgot-password">
                          <span className={"text-legendyColor"}>Zapomenuté heslo?</span>
                        </Link>
                      </span>
                    </div>

                </CenteredForm>
            </div>
        </Layout>
    )
}

export default LoginPage
